// tslint:disable:jsx-no-lambda
import { IconNames } from '@blueprintjs/icons'
import React, { Component, ReactNode } from 'react'
import { TranslationFunction } from 'react-i18next'
import { Route, RouteComponentProps, Switch } from 'react-router-dom'

import { NewAspireRoute } from '../new/NewAspireRoute'
import { i18nKeys } from './app.i18n'
import { ADMIN_USER_VIEW_BASE, links } from './app.links'
import { User } from './auth'
import { ActivityBarNavlink, AvatarSizes, Sidebar, UserAvatar } from './shared'
import { AdminNav, FunctionalNav, PersonalNav, RegionalNav, ReportsNav, TeamNav } from './sidebar-navigation'

type AppAsideProps = {
  user: User
  t: TranslationFunction
} & RouteComponentProps<{}>

export class AppAside extends Component<AppAsideProps> {
  render() {
    const { user, t, location } = this.props
    const isAdminLinkActive = location.pathname.indexOf(ADMIN_USER_VIEW_BASE) !== -1

    return (
      <Sidebar>
        {{
          activity: (
            <>
              <ActivityBarNavlink
                to={links.frontFace.personal.home()}
                icon={IconNames.PERSON}
                label={t(i18nKeys.frontFace.activityBar.personal)}
                notifyWhen={['GoalNotificationCount', 'ReviewNotificationCount', 'FeedbackNotificationCount']}
              />
              {(user.hasSubordinates || user.hasFormerTeam) && (
                <ActivityBarNavlink
                  to={links.frontFace.team.home()}
                  icon={IconNames.PEOPLE}
                  label={t(i18nKeys.frontFace.activityBar.team)}
                  notifyWhen={['MyTeamNotificationCount', 'TeamGoalsNotificationCount', 'TeamReviewNotificationCount']}
                />
              )}
              {user.isFunctionalManager && (
                <ActivityBarNavlink
                  icon={IconNames.FUNCTION}
                  label={t(i18nKeys.frontFace.activityBar.functional)}
                  to={links.frontFace.functional.home()}
                />
              )}
              {user.isRegionalDirector && (
                <ActivityBarNavlink
                  icon={IconNames.GLOBE}
                  label={t(i18nKeys.frontFace.activityBar.regional)}
                  to={links.frontFace.regional.home()}
                />
              )}

              <div className="activity-bar__footer">
                {/* <ActivityBarNavlink
                  to={links.frontFace.allstars.home()}
                  icon={IconNames.STAR_EMPTY}
                  label={t(i18nKeys.frontFace.activityBar.allstars)}
                /> */}
                {user.accessRoles.canUseAdministrationSection && (
                  <ActivityBarNavlink
                    icon={IconNames.CONTROL}
                    to={links.admin.home()}
                    label={t(i18nKeys.frontFace.activityBar.admin)}
                    isActive={isAdminLinkActive}
                  />
                )}
                {user.accessRoles.canViewPerson && (
                  <ActivityBarNavlink
                    to={links.reports.home()}
                    icon={IconNames.FOLDER_SHARED_OPEN}
                    label={t(i18nKeys.admin.activityBar.reports)}
                  />
                )}
                <ActivityBarNavlink
                  to={links.personProfile.home()}
                  shortcuttedLabel
                  icon={
                    <UserAvatar
                      imageSource={user.imageUrls.thumb34}
                      userName={user.userDisplayName}
                      avatarSize={AvatarSizes.LIST}
                      inline
                    />
                  }
                  label={user.surname}
                />
                <ActivityBarNavlink
                  dataTest="logOutSidebarMenuItem"
                  icon={IconNames.POWER}
                  label={t(i18nKeys.frontFace.activityBar.logout)}
                  to={links.auth.logout()}
                />
              </div>
            </>
          ),
          nav: this.renderNav(),
        }}
      </Sidebar>
    )
  }

  private renderNav(): ReactNode {
    const { match, user, t, location } = this.props

    const hiddenSideMenu = [links.personProfile.home(), links.frontFace.allstars.home()]

    return hiddenSideMenu.some((item) => item === location.pathname) ? null : (
      <Switch>
        <Route
          path={links.frontFace.personal.home(match.path)}
          render={(props) => <PersonalNav user={user} t={t} {...props} />}
        />
        <Route
          path={links.frontFace.team.home(match.path)}
          render={(props) => <TeamNav user={user} t={t} {...props} />}
        />
        <Route
          path={links.frontFace.functional.home(match.path)}
          render={(props) => <FunctionalNav t={t} {...props} />}
        />
        <Route path={links.frontFace.regional.home(match.path)} render={(props) => <RegionalNav t={t} {...props} />} />
        <Route path={links.reports.home(match.path)} render={(props) => <ReportsNav t={t} {...props} />} />
        <Route path={links.admin.home()} render={(props) => <AdminNav user={user} t={t} {...props} />} />
        <Route
          path={links.frontFace.team.byUser.homeFromAdmin(':id')}
          render={(props) => <AdminNav user={user} t={t} {...props} />}
        />
        <NewAspireRoute message={'app-aside'} />
      </Switch>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/app-aside.tsx